import { createApi } from "../../../../utils/createApi";
import { saveAs } from "file-saver";

// "Download Camera Overview" (Site Cameras header): one CSV row per
// camera on the site with its settings (immix email, products, slicing,
// ignore zones, resolution, input #, last motion).
export const downloadCameraOverview = async (siteId: string | number) => {
  const AxiosUI = createApi("");
  const response = await AxiosUI.get(
    `site_settings_report/${siteId}/cameras_csv/`,
    { responseType: "blob" }
  );
  const blob = new Blob([response.data], { type: "text/csv" });
  saveAs(blob, `camera_overview_site_${siteId}.csv`);
};
